// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__dLX2S","boxTitle":"Qualiphy_boxTitle__3DRy6","box":"Qualiphy_box__1aL0g","toggleWrap":"Qualiphy_toggleWrap__1tk6b"};